import React from 'react';

const ArvanPlayerComponent = ({ title, configUrl }) => {
    return (
        <iframe
            id="ir1p"
            width="100%"
            height="100%"
            frameBorder="0"
            title={title}
             src={`https://player.arvancloud.ir/?config=${configUrl}`}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
        ></iframe>
    );
};

export default ArvanPlayerComponent;